import { ComponentType } from 'react';

import Loadable from '@townsquare/loadable';
import type { LoadableComponent } from '@townsquare/loadable/types';
import { RouteContext } from '@townsquare/router/routing-types';

export const SearchRedirectAction: ComponentType<RouteContext> & LoadableComponent = Loadable({
	loader: () => import(/* webpackChunkName: "SearchRedirectAction" */ './SearchRedirectAction'),
	loading: () => null,
});
